// extracted by mini-css-extract-plugin
module.exports = {"brandLi":"BrandEntry_brandLi__AAzaN","brandEntry":"BrandEntry_brandEntry__lAugT","accessibilityButton":"BrandEntry_accessibilityButton__QHS0B"};